module.exports = __webpack_public_path__ + "static/media/MANA-logo.48316d69.png";